import { render } from "./buttonEnat.vue?vue&type=template&id=1e87db48&scoped=true"
import script from "./buttonEnat.vue?vue&type=script&lang=js"
export * from "./buttonEnat.vue?vue&type=script&lang=js"

import "./buttonEnat.vue?vue&type=style&index=0&id=1e87db48&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\horva\\Documents\\nodejs\\production\\enat05\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e87db48"]])

export default __exports__